'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dLogin$002dHelper$0024$0024anon$00244 from "./presto.-Login-Helper$$anon$4.js";
import * as $j_presto$002etypes$0024proto$0024$002dLogoff$002dResponse$0024 from "./presto.types$proto$-Logoff-Response$.js";
var $p;
/** @constructor */
function $c_Lpresto_LoginHelper$$anon$3() {
  this.b4S = null;
  this.b4K = null;
  this.b4L = false;
  this.b4T = null;
  this.b4U = false;
  this.b4X = null;
  this.b4Q = null;
  this.b4R = false;
  this.b4M = null;
  this.b4N = false;
  this.b4O = null;
  this.b4P = false;
  this.b4V = false;
  this.b4W = false;
  this.b4S = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.b4X = "LogoffResponse";
}
export { $c_Lpresto_LoginHelper$$anon$3 as $c_Lpresto_LoginHelper$$anon$3 };
$p = $c_Lpresto_LoginHelper$$anon$3.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_LoginHelper$$anon$3;
/** @constructor */
function $h_Lpresto_LoginHelper$$anon$3() {
}
export { $h_Lpresto_LoginHelper$$anon$3 as $h_Lpresto_LoginHelper$$anon$3 };
$h_Lpresto_LoginHelper$$anon$3.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.b4S;
});
$p.L = (function() {
  if ((!this.b4L)) {
    this.b4K = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.b4L = true;
  }
  return this.b4K;
});
$p.O = (function() {
  if ((!this.b4U)) {
    this.b4T = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.b4U = true;
  }
  return this.b4T;
});
$p.E = (function() {
  return this.b4X;
});
$p.t = (function() {
  if ((!this.b4R)) {
    this.b4Q = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("restored", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b4R = true;
  }
  return this.b4Q;
});
$p.M = (function() {
  if ((!this.b4N)) {
    this.b4M = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().ar, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.b4N = true;
  }
  return this.b4M;
});
$p.Q = (function() {
  if ((!this.b4P)) {
    this.b4O = new $j_presto$002e$002dLogin$002dHelper$0024$0024anon$00244.$c_Lpresto_LoginHelper$$anon$4();
    this.b4P = true;
  }
  return this.b4O;
});
$p.w = (function() {
  if ((!this.b4W)) {
    this.b4V = false;
    this.b4W = true;
  }
  return this.b4V;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee27) => ((p) => \u03b4scrutinee27.cGX(p)))($j_presto$002etypes$0024proto$0024$002dLogoff$002dResponse$0024.$m_Lpresto_types$proto$LogoffResponse$())));
});
var $d_Lpresto_LoginHelper$$anon$3 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_LoginHelper$$anon$3, "presto.LoginHelper$$anon$3", ({
  LX: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_LoginHelper$$anon$3 as $d_Lpresto_LoginHelper$$anon$3 };
//# sourceMappingURL=presto.-Login-Helper$$anon$3.js.map
